<div (click)="click($event)" *ngIf="visible" class="popup-overlay">
  <div class="popup">
    <ng-content></ng-content>
  </div>
</div>
